module.exports = __webpack_public_path__ + "img/6.048d503b.jpg";